import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
  loading: false,
  userData: null,
  email: null,
  userProfile: {},
  passwordData: {},
  userImages: [],
  error: null,
  profileCreated: false,
  authToken: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    // user login
    case actionTypes.LOGIN_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        authToken: action?.payload?.data?.token || null,
        userData: action.payload,
        error: null,
      };
    case actionTypes.LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //user registration
    case actionTypes.REGISTER_USER_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      }
    case actionTypes.REGISTER_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // User Profile Details
    case actionTypes.USER_PROFILE_DETAILS_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.USER_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      }
    case actionTypes.USER_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // user's Images add and update
    case actionTypes.USER_IMAGES_UPLOAD_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.USER_IMAGES_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        userImages: action.payload,
        error: null,
      }
    case actionTypes.USER_IMAGES_UPLOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // User Forgot Password
    case actionTypes.USER_FORGOT_PASSWORD_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.USER_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        email: action.payload.email,
        error: null,
      }
    case actionTypes.USER_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // User reset Password
    case actionTypes.USER_RESET_PASSWORD_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.USER_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      }
    case actionTypes.USER_RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // User change Password
    case actionTypes.CHANGE_PASSWORD_INIT:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        passwordData: action.payload,
        error: null,
      }
    case actionTypes.CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    //logout
    case actionTypes.LOGOUT_INIT:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        authToken: null, // Remove auth token
        userData: null,  // Clear user data
        error: null,
      };

    case actionTypes.LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
